import { defineStore } from 'pinia'
import { ref } from "vue";
import { request } from "@/ts/request";
import { RequestStatus } from "@/ts/interfaces/requests/statusEnum";
import { authSignUpPath } from "@/ts/apiRoutes";
import { UserData, SignUpData } from "@/ts/interfaces/requests/user";
// import { useAuthLoginStore } from "@/stores/auth/login.store";

// const authLoginStore = useAuthLoginStore()

export const useAuthSignUpStore = defineStore('api-auth-signup',  () => {
    const status = ref<RequestStatus | null >(RequestStatus.INITIAL)

    const user = ref<UserData>({
        name: '',
        email: ''
    })

    async function signUp(data: SignUpData) {
        const response = await request(authSignUpPath, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Content-type': 'application/json; charset=UTF-8',
            },
        })

        if(response.ok) {
            status.value = RequestStatus.SUCCESS
            /* const data  = */ await response.json()

            // authLoginStore.loginAction(data)
            // user.value = authLoginStore.user
        }

        return user
    }

    return { status, signUp }
})